import { sort } from "../../utils/utils";

export const getVersionHistory = (outcome) => {
  if (outcome.version_history.length === 0) {
    return [outcome];
  } else {
    return [outcome, getVersionHistory(outcome.version_history[0])].flat();
  }
};

export const getCurrentVersion = (outcome) => {
  const versionHistory = getVersionHistory(outcome);
  const now = new Date();
  for (let i = 0; i < versionHistory.length; i++) {
    if (
      versionHistory[i].effective_term === null ||
      new Date(versionHistory[i].effective_term?.start_at) <= now
    ) {
      return versionHistory[i];
    }
  }
};

export const getVersionByDate = (outcome, date) => {
  const versionHistory = getVersionHistory(outcome);
  for (let i = 0; i < versionHistory.length; i++) {
    if (
      versionHistory[i].effective_term === null ||
      new Date(versionHistory[i].effective_term?.start_at) <= date
    ) {
      return versionHistory[i];
    }
  }
};

export const getFutureVersions = (outcome) => {
  const versionHistory = getVersionHistory(outcome);
  const currentVersion = getCurrentVersion(outcome);
  const index = versionHistory.findIndex((v) => v.id === currentVersion.id);
  return versionHistory.slice(0, index);
};

export const getPastVersions = (outcome) => {
  const versionHistory = getVersionHistory(outcome);
  const currentVersion = getCurrentVersion(outcome);
  const index = versionHistory.findIndex((v) => v.id === currentVersion.id);
  return versionHistory.slice(index + 1);
};

export const hasUnmappedRatingScale = (outcome, mappings) => {
  let hasUnmapped = false;
  outcome.rating_scales.forEach((ratingScale) => {
    const mapping = mappings.find(
      (mapping) => mapping.id === ratingScale.rating_to_mastery_level_map
    );
    if (!mapping || mapping.is_mapped === false) {
      hasUnmapped = true;
    }
  });
  return hasUnmapped;
};

export const isArchived = (outcome) => {
  return (
    !!outcome.archive_term &&
    new Date(outcome.archive_term.start_at).setHours(0, 0, 0, 0) <=
      new Date().setHours(0, 0, 0, 0)
  );
};

export const isArchivedByDate = (outcome, date) => {
  return (
    !!outcome.archive_term && new Date(outcome.archive_term.start_at) <= date
  );
};

export const pendingArchive = (outcome) => {
  return (
    !!outcome.archive_term &&
    new Date(outcome.archive_term.start_at).setHours(0, 0, 0, 0) >
      new Date().setHours(0, 0, 0, 0)
  );
};

export const removeNewLines = (str) => {
  return str.replace(/(\r\n|\n|\r)/g, "");
};

export const sortOutcomes = (
  outcomes,
  getOutcome = (lo) => lo,
  nameProperty = "name",
  statementProperty = "statement"
) => {
  return sort(
    outcomes,
    (lo) =>
      `${getOutcome(lo)[nameProperty]}: ${getOutcome(lo)[statementProperty]}`
  );
};

export const getOriginalOutcomeVersion = (outcome) => {
  const versionHistory = getVersionHistory(outcome);
  return versionHistory[versionHistory.length - 1];
};
